import React from 'react';
import { PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { WhatsAppCta } from './WhatsAppCta';
import { specialties } from '../data/services';
import { WHATSAPP_DISPLAY, whatsappLink } from '../utils/whatsapp';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/310cca22-19cf-49a6-805d-dd8a1cd2db26.jpg';
export function Hero() {
  return <header className="relative overflow-hidden bg-ink" data-id="element-80" data-mp="129h1nq0lv4eh">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 pb-14 pt-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:px-8 lg:pb-24 lg:pt-16" data-id="element-81" data-mp="128yye9fizpx2">
        <div className="order-2 lg:order-1" data-id="element-82" data-mp="sb1c3rh88373">
          <p className="font-display text-xs uppercase tracking-[0.45em] text-gold" data-id="element-83" data-mp="s9q93tvluzh1">
            Dr. Solución
          </p>

          <h1 className="mt-4 font-display text-4xl leading-[1.05] text-gold-soft sm:text-5xl lg:text-6xl" data-id="element-84" data-mp="neknkw647mth">
            Amarres, dominios,
            <br data-id="element-85" data-mp="3825zatgqudmy" />
            atracción y separación
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/75" data-id="element-86" data-mp="3j8iyd2s0imwa">
            Con mi don y secreto psíquico espiritual, seguro y confiable,
            soluciono todo problema con el poder del Señor, los santos y los
            espíritus.
          </p>

          <ul className="mt-6 flex flex-wrap gap-2" data-id="element-87" data-mp="399thndbur8hm">
            {specialties.map(item => <li key={item} className="rounded-full border border-gold/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-gold-soft/90" data-id="element-88" data-mp="3e7uxlpdzerov">
                {item}
              </li>)}
          </ul>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-89" data-mp="2qkwk90l5rzv6">
            <WhatsAppCta size="lg" label="¡¡Consulta ahora!!" data-id="element-90" data-mp="2vi56bc9fgo1p" />
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-lg font-semibold text-gold-soft underline decoration-gold/40 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-white" data-id="element-91" data-mp="2hj5e5umphr0s">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-92" data-mp="najfrjc2u5cw" />
              {WHATSAPP_DISPLAY}
            </a>
          </div>

          <p className="mt-6 inline-flex items-center gap-2 text-sm font-medium uppercase tracking-[0.2em] text-white/60" data-id="element-93" data-mp="ia5jeyju8jup">
            <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-94" data-mp="1b0vubd1tv0cg" />
            Trabajo garantizado · Atención inmediata
          </p>
        </div>

        <div className="relative order-1 lg:order-2" data-id="element-95" data-mp="162ccnou9oapw">
          <div aria-hidden="true" className="absolute -inset-6 rounded-[2.5rem] bg-gold/10 blur-3xl" data-id="element-96" data-mp="1126o4hjan4c1" />
          <img src={HERO_IMAGE} alt="Dr. Solución, maestro espiritual, en oración frente a su altar de velas" className="relative w-full rounded-[2rem] border border-gold/25 object-cover shadow-candle" data-id="element-97" data-mp="x0l48c8cdpsc" />
        </div>
      </div>
    </header>;
}